module.exports = __webpack_public_path__ + "img/discount-left.204529b3.svg";